import React, { useState, useEffect } from "react";
import style from "./AdHocPaymentProof.module.css";

const AdHocPaymentProof = (props) => {
  const [inputList, setInputList] = useState([]);
  const [imageErr, setImageError] = useState("");

  const [max_upload, setMaxUpload] = useState("");

  useEffect(() => {
    let max_upload =
      localStorage.getItem("SETTING_INFO") &&
      JSON.parse(localStorage.getItem("SETTING_INFO")).max_paymentproof_upload;

    setMaxUpload(max_upload);
  }, [max_upload]);

  // handle input change

  const handleInputChangeFile = (e, index) => {
    const { name, files } = e.target;

    if (files && files[0]) {
      let FileSize = files && files[0].size / 1024 / 1024; // in MB
      if (/\.(jpe?g|png|svg|pdf)$/i.test(files && files[0].name) === false) {
        setImageError("This type of file extension is not allowed");
        let uploadflag = true;
        props.getImageError(uploadflag);
      } else {
        let uploadflag;
        if (FileSize > 2.0) {
          setImageError("Please upload file less than 2MB!");
          uploadflag = true;
          props.getImageError(uploadflag);
        } else {
          uploadflag = false;
          setImageError("");
          const list = [...inputList];
          list[index][name] = files[0];
          setInputList(list);
          props.getPaymentProof(list);
          props.getImageError(uploadflag);
        }
      }
    }
  };
  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...inputList];
    list[index][name] = value;
    setInputList(list);
    props.getPaymentProof(list);
  };

  // handle click event of the Remove button
  const handleRemoveClick = (index) => {
    setImageError("");
    const list = [...inputList];
    list.splice(index, 1);
    setInputList(list);
    props.getPaymentProof(list);
  };
  // handle click event of the Add button
  const handleAddClick = () => {
    setImageError("");
    setInputList([...inputList, { selectedFile: "", description: "" }]);
  };

  return (
    <div className={style.uloadDocMainWrapper}>
      <div className={`form-controls-wrapper ${style.uploadDocFormWrapper}`}>
        <div className="mb-3">
          {inputList.length >= 0 && inputList.length < max_upload && (
            <button
              type="button"
              onClick={handleAddClick}
              className="ttm-secondary-btn tmed-secondary-btn"
            >
              <i className="fa fa-plus mr-2" aria-hidden="true"></i>
              Add
            </button>
          )}
        </div>
        {inputList.map((x, i) => {
          return (
            <div className="box" key={i}>
              <div className={`row ${style.mobileUploadDeocWrapper}`}>
                <div className="col-8 col-sm-6 col-md-3 col-lg-4.5 col-xl-4">
                  {(!x.selectedFile || (typeof x.selectedFile == Object && !x.selectedFile.name) ) && (
                  <div className="form-group">
                    <div className={style.uploadBtnWrapper}>
                      <button type="button" className={style.uploadBtn}>
                        <i className="fa fa-upload mr-2" aria-hidden="true"></i>{" "}
                        Upload
                      </button>
                      <input
                        type="file"
                        name="selectedFile"
                        onChange={(e) => handleInputChangeFile(e, i)}
                        title={
                          x.selectedFile ? x.selectedFile.name : x.selectedFile
                        }
                      />
                    </div>
                  </div>)}
                {/* </div>
                <div className="order-3 order-sm-3 order-md-2 col-sm-12 col-md-3 col-lg-3 col-xl-2"> */}
                {(x.selectedFile || (typeof x.selectedFile == Object && x.selectedFile.name) ) && (
                  <div className={`form-group ${style.uploadedText}`}>
                    {/* {x.selectedFile && x.selectedFile.name.replace("C:\\fakepath\\", "")} */}
                    {x.selectedFile ? x.selectedFile.name : x.selectedFile}
                  </div>)}
                </div>
                <div className="order-4 order-sm-4 order-md-3 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                  <div className="form-group">
                    <input
                      className={`form-control ${style.description}`}
                      name="description"
                      placeholder="Description"
                      value={x.description}
                      onChange={(e) => handleInputChange(e, i)}
                    />
                  </div>
                </div>
                <div
                  className={`oder-2 oder-sm-2 order-md-4 col-4 col-sm-6 col-md-1 col-lg-1 col-xl-1 ${style.pullRightIcon}`}
                >
                  {inputList.length > 0 && (
                    <i
                      className={`fa fa-times ${style.deleteIcon}`}
                      aria-hidden="true"
                      onClick={() => handleRemoveClick(i)}
                    ></i>
                  )}
                </div>
              </div>
            </div>
          );
        })}
        {/* <div style={{ marginTop: 20 }}>{JSON.stringify(inputList)}</div> */}
      </div>
      <span className="error">{imageErr ? imageErr : ""}</span>
    </div>
  );
};

export default AdHocPaymentProof;
